/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/compass-otg-3': {
    width: 210,
    height: 210,
    viewBox: '0 0 210 210',
    data: `
        <g class="layer">
            <title>Layer 1</title>
            <path d="m210,105c0,57.99 -47.01,105 -105,105c-57.99,0 -105,-47.01 -105,-105c0,-57.99 47.01,-105 105,-105c57.99,0 105,47.01 105,105z" fill="black" id="svg_1"/>
            <path d="m107.3,10l-22.3,94.83l44.42,0l-22.21,-94.83l0.09,0z" fill="#FF1010" id="svg_2" transform="matrix(1 0 0 1 0 0)"/>
            <path d="m107.22,199.83l22.21,-94.83l-44.43,0l22.22,94.83z" fill="white" id="svg_3"/>
        </g>
    `
  }
})
